import EmptyPage from 'common/components/empty-page';
import { PlanApplyButton } from 'components/plans/plan-apply-modal';
import PlanCreateButton from 'components/plans/plan-create-button';
import { useNavigate } from 'react-router-dom';

const EmptyPlans = ({ isLoading }) => {
  const navigate = useNavigate();
  return (
    <EmptyPage
      title={
        isLoading
          ? 'Loading Your Plans'
          : 'Get a Quote for ReLease in Under a Minute'
      }
      subtitle={
        isLoading
          ? 'Please wait while we load your plans.'
          : "You don't have any active plans or quotes yet. Once you start a quote, you'll be able to view and manage them here."
      }
      FullButton={
      <PlanCreateButton
        mode='quote'
        title='Start Quote'
        theme='primary'
      />    }
      isLoading={isLoading}
    />
  );
};

export default EmptyPlans;
